import * as ComponentParser from 'Models/utils/component-parser';
import * as VanillaFactory from 'Models/utils/vanilla-factory';

// Define async components
const asyncComponents = [
    'header',
    'social-feed',
    'parallax-item',
    'slider',
    'control-video',
    'inline-video',
    'scrolled-into-view',
    'toggle-class',
    'count-up',
    'overlap-module',
    'scroll-to-element',
    'accordion',
    'clamping',
    'card-pages',
    'map',
    'flyouts',
    'contact-flyout',
    'form',
    'download-overlay',
    'tabs',
    'multioption-field',
    'checkbox-text',
    'delayed-classname',
    'image-gallery',
    'drag-drop-upload',
    'image-slideshow',
    'accept-cookies-message',
    'photo-wall',
    'timetable',
    'sticky',
    'pic-preview-cards',
];

// Register async components
asyncComponents.forEach((asyncComponent) => {
    VanillaFactory.registerComponent(asyncComponent, () =>
        import(
            /* webpackChunkName: "[request]" */ `Components/vanilla/${asyncComponent}`
        ),
    );
});

ComponentParser.registerFactory('vanilla', VanillaFactory.create);
